import { keyGen } from "../../../services/keygen";
import { roundTo } from "./BillingTools";

const decimalPlaces = 2;

const CreateInvoice = ({ tariff, items, reference, invoiceType }) => {
    return new ServiceInvoice(tariff, items, reference, invoiceType);
}

function ServiceInvoice(tariff, lineItems = [], reference = keyGen(8), invoiceType = 'sales') {
    // hack to deal with fall out from the aborted admin charge on LAA invoices !!!    

    // remove admin charges across the board
    this.items = lineItems.filter(({ key }) => key !== 'ADMIN01');
    
    // we got renamed QUIQR in tariff tier 1but some existing timesheets end up with both which causes mayhem in timesheet submission so ...
    if (this.items.find(item => item.key === 'ADMINX') && this.items.find(item => item.key === 'QUIQR')) {
        this.items = this.items.filter(({ key }) => key !== 'QUIQR');
    }

    this.invoiceType = invoiceType;
    this.reference = reference;
    this.date = new Date();
    var data = [];

    const getRate = ({ item, service }) => {
        if (!service) return 0;
        if (service?.basis === 'cost') return item.rate;

        if (invoiceType === 'sales') return service.chargeRate || service.rate;
        else if (invoiceType === 'purchase') return service.rate;
    }

    const getQuantity = item => item.quantity === 'NaN' || isNaN(item.quantity) ? 0 : item.quantity;

    const exists = ({ key }) => ~data.findIndex(i => i.key === key);

    // const check = item => {
    //     const actions = new Map();
    //     const clone = { ...item };

    //     actions.forEach((value, key) => clone[key] = value);

    //     return { ...clone };
    // }

    this.add = item => {
        if (!item.key) throw new Error('item must have a key');
        if (exists(item)) throw new Error('duplicate key');

        const validated = { ...item, quantity: getQuantity(item) }
        // if (!validated.key) {
        //     validated.key = keyGen(10)
        // }
        data.push(validated);
        return validated;
    }

    this.items.forEach(item => this.add(item));

    this.update = item => {
        if (!item?.key) throw new Error('item needs a key field to be updated');

        const index = data.findIndex(i => i.key === item.key);

        if (~index) {
            data[index] = { ...item, quantity: getQuantity(item) };

            console.log('update item', item, data[index])

            return data[index];
        }
        else {
            throw new Error('item not found');
        }
    }

    this.apply = (item) => {
        const index = data.findIndex(i => i.key === item.key);
        if (~index) {
            this.update(item);
        }
        else {
            this.add(item)
        }
    }

    this.remove = key => {
        const index = data.findIndex(i => i.key === key);

        if (~index) {
            const item = data[index];
            data = data.filter(i => i.key !== key);
            return { ...item };
        }
        else {
            throw new Error('item not found');
        }
    }

    this.clear = ({ field, value }) => {
        data = data.filter(i => i[field] !== value);
    }

    this.get = key => data.find(i => i.key === key);

    const netAmounts = (filter) => {
        return data
            .filter(item => !filter || filter.value === item[filter.field])
            .map(item => {
                const service = tariff[item.category][item.section][item.code];
                return {
                    amount: getRate({ service, item }) * getQuantity(item)
                };
            });
    }

    this.netTotal = () => {
        const total = netAmounts().reduce((total, { amount }) => total + amount, 0);
        return roundTo(total, decimalPlaces);
    }

    this.grandTotal = () => roundTo(this.netTotal() * (1 + tariff.taxRate), decimalPlaces);

    this.netSectionTotal = section => {
        return netAmounts({ field: 'section', value: section }).reduce((total, { amount }) => total + amount, 0)
    }

    this.netCategoryTotal = category => {
        return netAmounts({ field: 'category', value: category }).reduce((total, { amount }) => total + amount, 0)
    }

    this.items = () => {
        return data
            .filter(item => Boolean(tariff[item.category][item.section][item.code]))
            .map(item => {
                const service = tariff[item.category][item.section][item.code];
                const rate = getRate({ item, service }) || 0;
                return {
                    ...item,
                    rate,
                    amount: rate * getQuantity(item),
                    description: service.description,
                    measure: service.measure
                };
            });
    }

    this.taxRate = () => tariff.taxRate;
}

export default ServiceInvoice;

export {
    CreateInvoice
}